import {getParameterByName} from './util'

declare var gGDPR_forceLocale: any;

const GDPRCountries = [
	["at","Austria"  ],
	["be","Belgium"  ],
	["bg","Bulgaria"  ],
	["hr","Croatia"  ],
	["cy","Cyprus"  ],
	["cz","Czech Republic"  ],
	["dk","Denmark"  ],
	["ee","Estonia"  ],
	["fi","Finland"  ],
	["fr","France"  ],
	["de","Germany"  ],
	["gb","Great Britain"  ],
	["gr","Greece"  ],
	["hu","Hungary"  ],
	["is","Iceland"  ],
	["ie","Ireland"  ],
	["it","Italy"  ],
	["lv","Latvia"  ],
	["li","Liechtenstein"  ],
	["lt","Lithuania"  ],
	["lu","Luxembourg"  ],
	["mt","Malta"  ],
	["nl","Netherlands"  ],
	["no","Norway"  ],
	["pl","Poland"  ],
	["pt","Portugal"  ],
	["ro","Romania"  ],
	["sk","Slovakia"  ],
	["si","Slovenia"  ],
	["es","Spain"  ],
	["se","Sweden"  ]
];

export function findLocale() : any {
	
	let urlForcedLocale = getParameterByName( "cmpForceLocale" );

	if ( urlForcedLocale ) {
		console.log( "CMP: locale forced from cmpForceLocale URL parameter");
		return urlForcedLocale;
	}

    if ( typeof( gGDPR_forceLocale ) === "string" )
		if ( gGDPR_forceLocale.length > 0 ) {
			console.log( "CMP: locale forced from layout file");
			return gGDPR_forceLocale;
		}

	const locale = (navigator && (
			navigator.language ||
			// navigator.browserLanguage ||
			// navigator.userLanguage ||
			(navigator.languages && navigator.languages[0]) ||
			'en-us'
		) );

	return locale.toLowerCase();
 }

 export function visitorLocaleImpliesGDPR() {
	const currentLocal = findLocale();
	const [lang, cc] = currentLocal.split('-');

	const gdprApplies = ( GDPRCountries.find( (e) => e[0] === cc ) !== undefined );

	console.log( "CMP: Locale="+ currentLocal + "  gdpr= "+ gdprApplies);

	return gdprApplies;
}
